module.exports = __webpack_public_path__ + "media/bg.f6bf7861.mp4";